import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Typography } from '@components/Typography';
import Tooltip from '@components/Tooltip';
import { useTranslation } from '@hooks';
import { UpgradeIcon } from 'assets/images/icons';
import { ROLE } from '@constants/user';
import { ListItem } from './styles';

const SingleLevelItem = ({
    exact,
    item: { to, id, title, icon, upgradeRequired, upgradeClick },
    callback = {},
    disabled,
}) => {
    const { pathname } = useLocation();
    const { t } = useTranslation();
    const user = useSelector(state => state.auth.user);

    const isSuperAdmin = user?.role === ROLE.SUPER_ADMIN;

    return upgradeRequired ? (
        isSuperAdmin ? (
            <ListItem onClick={upgradeClick} type="single">
                <span />
                {icon}
                <Typography variant="body1">{title}</Typography>
                <UpgradeIcon style={{ marginLeft: 'auto' }} />
            </ListItem>
        ) : (
            <Tooltip placement="top" title={t('common.upgradeToUnlock')}>
                <ListItem isActive={exact ? pathname === to : pathname.includes(to)} type="single">
                    <span />
                    {icon}
                    <Typography variant="body1">{title}</Typography>
                    <UpgradeIcon style={{ marginLeft: 'auto' }} />
                </ListItem>
            </Tooltip>
        )
    ) : disabled ? (
        <Tooltip key={to} placement="top" title={t('common.subscriptionExpiredMsg')}>
            <ListItem isActive={exact ? pathname === to : pathname.includes(to)} type="single">
                <span />
                {icon}
                <Typography variant="body1">{title}</Typography>
            </ListItem>
        </Tooltip>
    ) : (
        <Link to={to} id={id} style={{ textDecoration: 'none', width: '100%' }} key={to}>
            <ListItem isActive={exact ? pathname === to : pathname.includes(to)} onClick={callback} type="single">
                <span />
                {icon}
                <Typography variant="body1">{title}</Typography>
            </ListItem>
        </Link>
    );
};

export default SingleLevelItem;
